// PageSync Faye Adapter
import Faye from '@/faye-shim.js'
import { isTestEnv, isDevEnv } from '@/helpers/env.js'

const PageSyncFayeAdapter = {
  name: "Faye",
  endpoint: null,
  faye: null,

  init(url) {
    const baseUrl = `${location.protocol}//${location.hostname}`
    this.endpoint = url || `${baseUrl}/faye`
    this.faye = new Faye.Client(this.endpoint, { retry: 2 })
    // Fix disconnect when download links are clicked
    this.faye.disable('autodisconnect')
    if (isTestEnv() || isDevEnv()) {
      this.faye.on('transport:up', () => {
        document.body.dataset.pageSyncConnected = 'true'
      })
      this.faye.on('transport:down', () => {
        document.body.dataset.pageSyncConnected = 'false'
      })
    }
  },

  subscribe(path, callback) {
    this.faye.subscribe(path, callback)
  },

  unsubscribe(path) {
    this.faye.unsubscribe(path)
  }
}

export default PageSyncFayeAdapter
